import HttpRequest from "@/services/http_request";

class ReportProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async getReportB1(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.getBlob(
      `/reg/enroll/report/B1?timestamp=${new Date().getTime()}`
    );
    return res;
  }

  async getReportB5(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      facultyid: this.variableParser(request.facultyid),
      courseid: this.variableParser(request.courseid),
      section: this.variableParser(request.section),
      reporttype: this.variableParser(request.reporttype),
      userid: this.variableParser(request.userid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.getBlob(
      `/reg/enroll/report/B5?timestamp=${new Date().getTime()}`
    );
    return res;
  }

  async getReportB5Section(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      courseid: this.variableParser(request.courseid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/enroll/report/B5getsection");
    const { data } = res.data;
    return data;
  }
}

export default ReportProvider;
